import React from "react"

import type { BookingSource } from "@/lib/booking_source"
import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"

export const BookingSourceContext =
  React.createContext<BookingSource.ContextData>({
    bookingSource: undefined,
    setBookingSource: contextPlaceholderFunction,
  })
